// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvBpgQ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.i7igOL {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.c3dZyE {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.Y2bxdX {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

._6Yo686 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-3);
}

.JbYPxV {
  display: grid;
  grid-template-columns: 20% 80%;
  gap: var(--spacing-3);
}

.QoNrXj {
  display: grid;
  grid-template-columns: 20% 80%;
  gap: var(--spacing-3);
}

.udC9ZN {
  display: flex;
  align-items: center;
  margin-top: var(--spacing-2);
}

@media (max-width: 1248px) {
  ._6Yo686,
  .JbYPxV,
  .QoNrXj {
    grid-template-columns: 1fr;
    gap: var(--spacing-4);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesPayerForm/ChargesPayerForm.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n}\n\n.sectionTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.fieldRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-3);\n}\n\n.fieldRowCepLogradouro {\n  display: grid;\n  grid-template-columns: 20% 80%;\n  gap: var(--spacing-3);\n}\n\n.fieldRowEstadoDescricao {\n  display: grid;\n  grid-template-columns: 20% 80%;\n  gap: var(--spacing-3);\n}\n\n.checkboxGroup {\n  display: flex;\n  align-items: center;\n  margin-top: var(--spacing-2);\n}\n\n@media (max-width: 1248px) {\n  .fieldRow,\n  .fieldRowCepLogradouro,\n  .fieldRowEstadoDescricao {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AvBpgQ`,
	"section": `i7igOL`,
	"sectionTitle": `c3dZyE`,
	"fieldGroup": `Y2bxdX`,
	"fieldRow": `_6Yo686`,
	"fieldRowCepLogradouro": `JbYPxV`,
	"fieldRowEstadoDescricao": `QoNrXj`,
	"checkboxGroup": `udC9ZN`
};
module.exports = ___CSS_LOADER_EXPORT___;
